import { ConfigurationControls } from "../ConfigurationControls/ConfigurationControls";
import { CustomSubconfigurationNavigationComponents } from "../CustomSubconfigurationNavigationComponents/CustomSubconfigurationNavigationComponents";

import { JSX } from "react";

import Box from "@mui/material/Box";
import {
  SubconfigurationNavigationComponents,
  SubconfigurationNavigationContent,
  SubconfigurationNavigationControl,
  SubconfigurationNavigationOrientation,
  SubconfigurationNavigationProps,
  useSubconfigurationNavigation,
  useSubconfigurationNavigationItems,
} from "@plansoft-configuration-renderer/components";
import { TextMode } from "@plansoft-configuration-renderer/framework";

import { SubconfigurationNavigationApiProvider } from "./SubconfigurationNavigationApi";

/**
 * Tab control on configuration level
 * @category UI
 * @param props
 * @returns
 */
export function CustomSubconfigurationNavigation(
  props: SubconfigurationNavigationProps,
): JSX.Element {
  const componentsMapper = props.custom?.renderAsIconNavigation
    ? CustomSubconfigurationNavigationComponents
    : SubconfigurationNavigationComponents;
  const {
    control = SubconfigurationNavigationControl.Stepper,
    orientation = SubconfigurationNavigationOrientation.Horizontal,
    components = componentsMapper,
    textMode = TextMode.PlainText,
  } = props;

  const items = useSubconfigurationNavigationItems({});

  const {
    activePath,
    setActivePath,
    resetActivePath,
    next,
    nextDisabled,
    previous,
    previousDisabled,
  } = useSubconfigurationNavigation(items);

  const { NavigationComponents, AlignmentComponents, ContentComponents } =
    components;

  const Navigation = NavigationComponents[control];
  const AlignmentComponent = AlignmentComponents[orientation];

  const activeItem = items.find((item) => item.path === activePath);
  const showDownloadUserManual =
    activeItem?.path.split("/")[1] === "XAS_PRODUCT_VIEW";

  return (
    <SubconfigurationNavigationApiProvider
      next={next}
      previous={previous}
      nextDisabled={nextDisabled}
      previousDisabled={previousDisabled}
    >
      <AlignmentComponent
        navigation={
          <Navigation
            textMode={textMode}
            orientation={orientation}
            activePath={activePath}
            setActivePath={setActivePath}
            items={items}
            navigationStyle={props.navigationStyle}
            showCompletenessIndicator={props.showCompletenessIndicator}
            stepperProps={props.stepperProps}
          />
        }
        content={
          activeItem ? (
            <>
              <ConfigurationControls
                showDownloadUserManual={showDownloadUserManual}
                onNextClicked={next}
                onPreviousClicked={previous}
                nextDisabled={nextDisabled}
                previousDisabled={previousDisabled}
                onResetClicked={resetActivePath}
                resetDisabled={false}
              />

              <Box sx={{ px: 0.5 }}>
                <SubconfigurationNavigationContent
                  item={activeItem}
                  components={ContentComponents}
                />
              </Box>
            </>
          ) : null
        }
      />
    </SubconfigurationNavigationApiProvider>
  );
}
